var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExtrusionOpPosterior(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 10C11.1127 10 6.90728 13.4551 5.95895 18.2494L5.21707 22L26.7827 22L26.0408 18.2494C25.0925 13.4551 20.8871 10 15.9999 10ZM3.99697 17.8613C5.13059 12.1302 10.1577 8 15.9999 8C21.842 8 26.8692 12.1302 28.0028 17.8613L29.2171 24L2.78271 24L3.99697 17.8613L4.97796 18.0553L3.99697 17.8613Z",
    fill: "#647B8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 13.9072C13.4343 13.9072 11.1071 15.4113 10.0534 17.7505L9.46581 19.0549L22.534 19.0549L21.9464 17.7505C20.8927 15.4113 18.5655 13.9072 15.9999 13.9072ZM23.1437 20.0549L8.85604 20.0549L4.2958 23.403C4.07321 23.5665 3.76028 23.5185 3.59686 23.2959C3.43343 23.0733 3.48139 22.7604 3.70398 22.597L8.29031 19.2297L9.14159 17.3398C10.3568 14.642 13.0409 12.9072 15.9999 12.9072C18.9589 12.9072 21.6429 14.6419 22.8582 17.3398L23.7095 19.2297L28.2958 22.597C28.5184 22.7604 28.5664 23.0733 28.4029 23.2959C28.2395 23.5185 27.9266 23.5665 27.704 23.403L23.1437 20.0549Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtrusionOpPosterior);
export default __webpack_public_path__ + "static/media/extrusion-op-posterior.4aecf1b4.svg";
export { ForwardRef as ReactComponent };